import { ITranslations } from 'types/common';
import { ScriptsTransFields } from './types';
import en from 'translations/en/scripts.json';
import pl from 'translations/pl/scripts.json';
import sl from 'translations/sl/scripts.json';

export const scriptsTranslations: ITranslations<ScriptsTransFields> = {
  name: 'scripts',
  en,
  pl,
  sl,
};
